<template>
  <div>
    <b-row class="my-3">
      <b-col cols="12" sm="12" md="12" lg="5" xl="5">
        <b-card no-body>
          <b-card-header tag="header" header-bg-variant="transparent">
            <h5><i class="fa-light fa-square-check"></i> Habilitar usuário</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-form-group>
                <multiselect
                  id="user-select"
                  v-model="selectedUser"
                  :options="userOptions"
                  :searchable="true"
                  :multiple="false"
                  label="name"
                  track-by="email"
                  placeholder="Selecionar usuário (Sistema CPV)"
                  @input="onUserSelected"
                ></multiselect>
              </b-form-group>
            </b-form>
            <div v-if="objectLogin.data === ''">
              <div v-if="objectLogin.urlAprovada != 'nao-autorizado'">
                <b-alert 
                  fade 
                  variant="danger" 
                  v-if="!gravando && !loading && showAlertError" 
                  show 
                  @dismissed="dismissCountDown=0"
                >
                  <b-progress
                    variant="danger"
                    :max="dismissSecs"
                    :value="dismissCountDown"
                    height="4px"
                  ></b-progress>
                  <div class="d-flex align-items-center">
                    <i class="far fa-thumbs-down fa-2xl mr-3"></i>
                    <div class="d-flex flex-column w-100">
                      <strong class="d-block"> Ops... Atenção</strong>
                      <hr class="my-2 w-100">
                      <span>Verifique se o usuário foi selecionado!</span>
                    </div>
                  </div>
                </b-alert>
              </div>
            </div>
            <b-button class="btn-check" block variant="transparent" @click="postData()" v-if="!loading">Verificar acesso</b-button>
            <div class="d-flex flex-column align-items-center justify-content-center" v-if="!!loading">
              <b-spinner label="Spinning" class="color-default"></b-spinner>
              <i class="lead d-block color-default my-2">Por favor, aguarde...</i>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="7" xl="7" class="my-3 my-lg-0">
        <b-card class="shadow-sm" no-body>
          <b-card-header tag="header" header-bg-variant="transparent">
            <h5>Acesso e-24h</h5>
          </b-card-header>
          <b-card-body>
            <div v-if="!objectLogin.data == ''">
              Por favor selecione o usuário para verificar se possuí acesso.
            </div>
            <div v-if="objectLogin.data != ''">
              <div v-if="objectLogin.urlAprovada !== 'nao-autorizado' && !gravando && !loading">
                <b-alert 
                  fade
                  variant="success"
                  v-if="!gravando && !loading && showAlertSuccess"
                  show 
                  @dismissed="dismissCountDown=0"
                >
                  <b-progress
                    variant="success"
                    :max="dismissSecs"
                    :value="dismissCountDown"
                    height="4px"
                  ></b-progress>
                  <div class="d-flex align-items-center my-2">  
                    <i class="far fa-thumbs-up fa-2xl mr-3"></i>   
                    <div class="d-flex flex-column w-100">
                      <strong class="d-block">Usuário: {{ selectedUser.name }}</strong>
                      <hr class="my-2 w-100">
                      <span>Está com o acesso habilitado!</span>
                    </div>
                  </div>
                </b-alert>
                <b-list-group>
                  <b-list-group-item><small><strong>Nome:</strong></small> {{ selectedUser.name }}</b-list-group-item>
                  <b-list-group-item><small><strong>E-mail:</strong></small> {{ selectedUser.email }}</b-list-group-item>
                  <b-list-group-item><small><strong></strong></small> {{ selectedUser.email }}</b-list-group-item>
                  <b-list-group-item>
                    <small><strong>URL:</strong></small>
                    {{ objectLogin.urlAprovada }}
                    <hr class="my-3">
                    <div class="d-block text-center">
                      <b-button type="button" class="copyUrl my-3" variant="transparent" @click="copiarLink"> <i class="far fa-copy"></i> Copiar Link</b-button>
                    </div>
                  </b-list-group-item>
                </b-list-group>
                <b-alert class="my-2" fade v-if="copiado === true" variant="success" show>
                  <i class="far fa-thumbs-up mr-3"></i>Link copiado com sucesso!
                </b-alert>
              </div>

              <div v-else>
                <b-alert 
                  fade 
                  variant="danger" 
                  v-if="!gravando && showAlertError" 
                  show 
                  @dismissed="dismissCountDown=0"
                >
                  <b-progress
                    variant="danger"
                    :max="dismissSecs"
                    :value="dismissCountDown"
                    height="4px"
                  ></b-progress>
                  <div class="d-flex align-items-center">
                    <i class="far fa-thumbs-down fa-2xl mr-3"></i>
                    <div class="d-flex flex-column w-100">
                      <strong class="d-block">Usuário: {{ selectedUser.name }}</strong>
                      <hr class="my-2 w-100">
                      <span>Usuário não está habilitado no e-24h!</span>
                    </div>
                  </div>
                </b-alert>
                <b-list-group>
                  <b-list-group-item><small><strong>Nome:</strong></small> {{ selectedUser.name }}</b-list-group-item>
                  <b-list-group-item><small><strong>E-mail:</strong></small> {{ selectedUser.email }}</b-list-group-item>
                </b-list-group>
                <div class="text-center">
                  <b-button type="button" class="new-user my-3" variant="transparent" @click="selectedUserE24h(gravando = true)" v-if="!loading">Cadastrar usuário no e-24h?</b-button>
                  <div v-if="loading">
                    <b-spinner label="Spinning" class="color-default"></b-spinner>
                    <i class="lead d-block color-default my-2">Por favor, aguarde...</i>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Vue from 'vue';
  import ApiService from '@/common/api.service';
  import Multiselect from 'vue-multiselect';

  import { LayoutPlugin } from 'bootstrap-vue';
  Vue.use(LayoutPlugin);

  import { FormGroupPlugin } from 'bootstrap-vue';
  Vue.use(FormGroupPlugin);

  import { ButtonPlugin } from 'bootstrap-vue';
  Vue.use(ButtonPlugin);

  import { SpinnerPlugin } from 'bootstrap-vue';
  Vue.use(SpinnerPlugin);

  import { AlertPlugin } from 'bootstrap-vue';
  Vue.use(AlertPlugin);

  import { FormInputPlugin } from 'bootstrap-vue';
  Vue.use(FormInputPlugin);

  import { TablePlugin } from 'bootstrap-vue';
  Vue.use(TablePlugin);
  
  export default {
    name: 'habilitaUserSistemaE24h',
    components: {
      Multiselect,
    },
    created() {
      this.loadUsers()
    },
    data() {
      return {
        gravando: false,
        objectUser: [],
        loading: false,
        selectedUser: null, // Armazena o email selecionado (string)
        filteredUsers: [], // Inicializa como array vazio
        objectLogin: {
          data: [],
        },
        items: [{}],
        objectUser24h: [],
        objectCadastro: [],
        userSistema: '', // Armazena o email para o backend
        search: '', // Para o campo de busca

        copiado: null,
        showAlertSuccess: false,
        showAlertError: false,
        dismissSecs: 3,
        dismissCountDown: 0,
        usuarioSelecionado: null,
      }
    },
    computed: {
      userOptions() {
        return this.filteredUsers
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name)) // ordena pelo nome
          .map((user) => ({
            name: user.name,
            email: user.email,
          }))
      },
    },
    methods: {
      async postData() {
        if (!this.selectedUser) {
          this.objectLogin = {
            data: '',
            urlAprovada: 'autorizado'
          }
          
          this.showAlertError = true
          this.startCountdown('erro')

          return
        }

        this.loading = true // Inicia o spinner
        try {
          const response = await ApiService.post('v1/login-24h', {
            emailUser: this.selectedUser?.email || null,
          })
          this.objectLogin = response.data
          console.log('Usuário vinculado com sucesso:', response.data)

          if (response.data?.data !== '' && response.data?.urlAprovada !== 'nao-autorizado') {
            this.showAlertSuccess = true
            this.startCountdown('sucesso')
          } else {
            this.showAlertError = true
            this.startCountdown('erro')
          }
        } catch (error) {
          console.error('Erro ao vincular usuário:', error)
          this.showAlertError = true
          this.startCountdown('erro')
        } finally {
            this.loading = false
        }
      },
      async loadUsers() {
        try {
          const response = await ApiService.post('v1/userSistema')
          this.objectUser24h = response.data
          this.filteredUsers = response.data.usuario || [] // Garante que seja um array
        } catch (error) {
          console.error('Erro ao carregar usuários:', error)
          this.filteredUsers = []
        }
      },

      async cadastroUserE24h() {
        this.loading = true // Inicia o spinner
        try {
          const response = await ApiService.get('v1/list-user-grava', {
            emailUser: this.selectedUser?.email || null,
            grava: 'Sim', // Envia o email
          })
          this.objectCadastro = response.data
          console.log('Usuário vinculado com sucesso:', response.data)
        } catch (error) {
          console.error('Erro ao vincular usuário:', error)
        } finally {
           this.loading = false
        }
      },

      filterUsers() {
        const searchTerm = this.search.toLowerCase()
        this.filteredUsers = this.objectUser24h.data.usuario.filter(
          (user) =>
            user.email.toLowerCase().includes(searchTerm) || // Filtra por email
            user.name.toLowerCase().includes(searchTerm), // Ou por nome
        )
      },
      // onUserSelected(user) {
      //   this.userSistema = user?.email || null
      // },

      // Ao invés de mostrar a url o usuário que fizer o vinculo, precisar clicar no botão copiar url
      async copiarLink() {
        const link = this.objectLogin.urlAprovada;

        if (!link || link === 'nao-autorizado') {
          this.copiado = false;
          setTimeout(() => {
            this.copiado = null
          }, 3000);
          return;
        }

        try {
          await navigator.clipboard.writeText(link);
          this.copiado = true;

          setTimeout(() => {
            this.copiado = null
          }, 3000);

        } catch (err) {
          console.error("ERROR ao copiar o link:", err)
          this.copiado = false;

          setTimeout(() => {
            this.copiado = null
          }, 3000);
        }
      },
      startCountdown(type) {
        // zera e reinicia
        this.dismissCountDown = this.dismissSecs
        clearInterval(this.timer)

        this.timer = setInterval(() => {
          if (this.dismissCountDown > 0) {
            this.dismissCountDown--
          } else {
            clearInterval(this.timer)
            this.timer = null
            if (type === 'sucesso') this.showAlertSuccess = false
            if (type === 'erro') this.showAlertError = false
          }
        }, 1000)
      },
      onUserSelected(user) {
        this.usuarioSelecionado = true;
        this.userSistema = user?.email || null;
        this.objectLogin = { data: '', urlAprovada: '' };
        this.showAlertSuccess = false;
        this.showAlertError = false;
      }
    },
  }
</script>
<style scoped>
h5 {
  margin-bottom: 0;
}

.btn-check, .copyUrl, .new-user {  
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  padding: 8px 16px;
}

.btn-check, .copyUrl, .new-user {
  border: 1px solid #805dca;
  color: #805dca;

  background-image: none;
  background: linear-gradient(90deg, #805dca 0%, #805dca 50%, transparent 50%, transparent 100%);
  background-size: 200% 100%;
  background-position: right;
  transition: background 0.8s ease, color 0.8s ease, border 0.8s ease;
}

.btn-check:hover, .copyUrl:hover, .new-user:hover {
  background-position: left;
  color: #fff;
}

.btn-check:focus, .copyUrl:focus, .new-user:focus {
  box-shadow: 0 0 0 0.2rem rgba(128, 93, 202, 0.25);
}

.color-default {
  color: #805dca;
}
</style>
